import axios from 'axios';
import { ManualFeed } from '../types/manual-feed.type';

// GET
// Returns feed.
// ​/ewosapi​/v1​/feeds/manual/company/{globalCompanyId}/feed/{feedId}
export const getManualFeed = async (globalCompanyId: string, feedId: string): Promise<ManualFeed> => {
  const res = await axios.get<ManualFeed>(`/ewosapi/v1/feeds/manual/company/${globalCompanyId}/feed/${feedId}`);
  return res.data;
};
